import React from "react";
import Slider from 'react-infinite-logo-slider';
import OpenAILogo from '../../assets/logos/openai.svg';
import styles from './ScrollingCompanies.module.css';

const companyLogos = [
  {
    name: 'Google',
    url: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg',
  },
  {
    name: 'Amazon',
    url: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg',
  },
  {
    name: 'Microsoft',
    url: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg',
  },
  {
    name: 'Apple',
    url: 'https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg',
  },
  {
    name: 'Tesla',
    url: 'https://upload.wikimedia.org/wikipedia/commons/b/bd/Tesla_Motors.svg',
  },
  {
    name: 'Meta',
    url: 'https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg',
  },
  {
    name: 'Netflix',
    url: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Netflix_2015_logo.svg',
  },
  {
    name: 'OpenAI',
    Logo: OpenAILogo,
  },
  {
    name: 'Adobe',
    url: 'https://upload.wikimedia.org/wikipedia/commons/6/6e/Adobe_Corporate_logo.svg',
  },
  {
    name: 'IBM',
    url: 'https://upload.wikimedia.org/wikipedia/commons/5/51/IBM_logo.svg',
  },
  {
    name: 'Salesforce',
    url: 'https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg',
  },
  {
    name: 'Nike',
    url: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/Logo_NIKE.svg',
  },
];

const ScrollingCompanies = () => {
  return (
    <section className={styles.section}>
    {/* Headline */}
    <div className={styles.headline}>
      <h2
        style={{
          fontSize: '20px',
          fontWeight: '700',
          color: 'rgb(13, 13, 13)',
          margin: 0,
        }}
      >
        Land your dream job
      </h2>
    </div>

    {/* Scrolling Logos */}
    <div className={styles.logos}>
      <Slider
        width="200px"
        duration={50}
        pauseOnHover={false}
        blurBorders={false}
      >
        {companyLogos.map((company) => {
          const Logo = 'Logo' in company ? company.Logo : null;

          return (
            <Slider.Slide key={company.name}>
              <div className={styles.logoSlot}>
                {Logo ? (
                  <Logo
                    aria-label={`${company.name} logo`}
                    role="img"
                    width="120"
                    height="50"
                    className={styles.logo}
                  />
                ) : (
                  <img
                    src={company.url}
                    alt={`${company.name} logo`}
                    width="120"
                    height="50"
                    className={styles.logo}
                  />
                )}
              </div>
            </Slider.Slide>
          );
        })}
      </Slider>
    </div>
  </section>

  );
};

export default ScrollingCompanies;
